import { uploadLog } from '@/utils/log-request.js'
import { LocalStorageKeys } from '@/utils/local_storage.js'
import { rsaDecryptWithPrivateKey } from '@/utils/sign_utils.js';

export default {
  install(Vue) {
    // 添加全局方法
    Vue.prototype.$errorLog = async function(methodName, message) {
			var userInfo = localStorage.getItem(LocalStorageKeys.USER_INFO);
			var userId = 0;
			if (userInfo != null) {
				const userInfoDe = await rsaDecryptWithPrivateKey(userInfo);
				userId = JSON.parse(userInfoDe).id;
			}
			const data = JSON.stringify({
        'user_id': userId,
        'method_name': methodName,
        'message': message
      })
      
      try {
        await uploadLog({
          'data': data
        })
      } catch (error) {
        console.error('Error logging failed:', error)
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/utils/error-log.js